import React from "react";

import AdminBoardsFeature from "../features/admin/board";

function AdminBoards(props) {
  return <AdminBoardsFeature {...props} />;
}

export default AdminBoards;
